import React, { useState, useRef, useEffect } from 'react';
import HistoryModal from '../../History/HistoryModal';
import Modal from '../../Modal';
import {Cureus} from '../../../Cureus';

const Invited = ({reviewershipsPath, createPath, templatePath}) => {

  const [tableData, setTableData] = useState(false);

  useEffect(() => {
    fetchData();
  }, [])

  const initEmailReminderFeature = () => {
    Cureus.Admin.MultipleReminders.init({
      btnSelector: ".bulk-email-button-reviewers-table",
      noNavSelector: true,
      tabPaneSelector: "#invited-reviewerships-datatable-container",
      templateName: "AcceptOrDeclineReview",
      templatePath: templatePath,
      createPath: createPath,
      async: true
    });
  }

  const removeClickHandlerFromEmailButton = () => {
    // Need this ownerwise Cureus.Admin.MultipleReminders will cause duplicate modals to open at the same time.
    $(".bulk-email-button-reviewers-table").off('click')
  }

  const populateTable = (fetchedTableData) => {
    var dt = $("#invited-reviewerships-table").DataTable({
      columns: [
        {width: '35px'},
        {width: '180px'},
        null,
        {width: '160px'},
        null,
        {width: '100px', class: 'centered'}
      ],
      columnDefs: [
        {targets: [1], orderData: [2]},
        {targets: [2], visible: false},
        {orderable: false, targets: [0, 5]}
      ],
      searching: false,
      dom: '<"row">tr<"row"<"large-8 columns pagination-details" <"pull-left"p><"pull-left showing-info"i>><"large-4 columns table-length-container"<"text-right"l>>>',
      "bAutoWidth": false,
      "fnDrawCallback": function(oSettings) {
        if (oSettings.fnRecordsDisplay() == 0) {
          $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
          $(oSettings.nTableWrapper).find('.dataTables_length').hide();
          $(oSettings.nTableWrapper).find('.dataTables_info').hide();
        } else if (oSettings._iDisplayLength > oSettings.fnRecordsDisplay()) {
          $(oSettings.nTableWrapper).find('.dataTables_info').show();
        } else {
          $(oSettings.nTableWrapper).find('.dataTables_paginate').show();
          $(oSettings.nTableWrapper).find('.dataTables_length').show();
          $(oSettings.nTableWrapper).find('.dataTables_info').show();
        }
        removeClickHandlerFromEmailButton()
        initEmailReminderFeature()
      },
      pageLength : 5,
      "lengthMenu": [5, 10, 25, 50, 100],
      "rowCallback": function(row) {
        let element = row.children[4].children[0]
        element.addEventListener('click',function() {
          openHistoryModal(element.dataset.articleId, element.dataset.reviewershipId)
        })
      }
    })

    dt.api().clear();
    for (var i = 0; i < fetchedTableData.reviewerships.length; i++) {
      let row = fetchedTableData.reviewerships[i];
      dt.fnAddData( [
          row.checkbox,
          row.most_recent_activity,
          row.sort_column,
          row.reviewer,
          row.title,
          row.reminder_history
      ], false)
    }
    dt.fnSort([[2, 'desc']])
    dt.fnDraw()
    $(document).foundation('reflow');    
  }

  const fetchData = () => {
    if(tableData) {
      populateTable(tableData)
      return;
    }
    $.ajax({
      type: 'GET',
      url: reviewershipsPath,
      data: {state: 'invited'},
      success: function(data) {
        setTableData(data)
        populateTable(data)
      }
    });
  }

  const openHistoryModal = (articleId, authorshipReviewershipId) => {
    Modal.open({
      children: <HistoryModal
          articleId={articleId}
          authorshipReviewershipId={authorshipReviewershipId}
        />
    });
  }


  return (
    <div className="channel-articles-datatable-container" id="invited-reviewerships-datatable-container">
      <table id="invited-reviewerships-table">
        <thead>
          <tr>
            <th><input type="checkbox" /></th>
            <th>Invitation date</th>
            <th></th>
            <th>Reviewer</th>
            <th>Title</th>
            <th>History</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>
  )
}

export default Invited;